/**
 * Generated from PlanterCustomizeLayout.fla
 */
export function PlanterCustomizeLayout(this: IPlanterCustomizeLayout) {
	const tab = this.tab;
	if (!tab[0] && tab.elementFactory) {
		tab[0] = tab.elementFactory(0,undefined);
	}
	if (tab[0]) {
		PlanterCustomizeLayout_tab1.call(tab[0] as IPlanterCustomizeLayout_tab1);
		tab[0].x = 765;
		tab[0].y = 364;
		if (tab[0].onLayout) tab[0].onLayout();
	}
	if (!tab[1] && tab.elementFactory) {
		tab[1] = tab.elementFactory(1,undefined);
	}
	if (tab[1]) {
		PlanterCustomizeLayout_tab2.call(tab[1] as IPlanterCustomizeLayout_tab2);
		tab[1].x = 765;
		tab[1].y = 364;
		if (tab[1].onLayout) tab[1].onLayout();
	}
	if (!tab[2] && tab.elementFactory) {
		tab[2] = tab.elementFactory(2,undefined);
	}
	if (tab[2]) {
		PlanterCustomizeLayout_tab3.call(tab[2] as IPlanterCustomizeLayout_tab3);
		tab[2].x = 765;
		tab[2].y = 364;
		if (tab[2].onLayout) tab[2].onLayout();
	}
	if (!tab[3] && tab.elementFactory) {
		tab[3] = tab.elementFactory(3,undefined);
	}
	if (tab[3]) {
		PlanterCustomizeLayout_tab4.call(tab[3] as IPlanterCustomizeLayout_tab4);
		tab[3].x = 765;
		tab[3].y = 364;
		if (tab[3].onLayout) tab[3].onLayout();
	}
	const bg = this.bg;
	PlanterCustomizeLayout_bg.call(this.bg);
	bg.x = -320;
	bg.y = 0;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const tabsDropShadow = this.tabsDropShadow;
	PlanterCustomizeLayout_tabsDropShadow.call(this.tabsDropShadow);
	tabsDropShadow.x = 765;
	tabsDropShadow.y = 413.5;
	tabsDropShadow.width = 433.00;
	tabsDropShadow.height = 437.00;
	if (tabsDropShadow.onLayout) tabsDropShadow.onLayout();
	const bench = this.bench;
	PlanterCustomizeLayout_bench.call(this.bench);
	bench.x = 505.5;
	bench.y = 664.25;
	bench.width = 951.00;
	bench.height = 232.50;
	if (bench.onLayout) bench.onLayout();
	const homeButton = this.homeButton;
	PlanterCustomizeLayout_homeButton.call(this.homeButton);
	homeButton.x = 108;
	homeButton.y = 164.5;
	homeButton.width = 146.00;
	homeButton.height = 151.00;
	if (homeButton.onLayout) homeButton.onLayout();
	const planter = this.planter;
	PlanterCustomizeLayout_planter.call(this.planter);
	planter.x = 295.5;
	planter.y = 594;
	planter.width = 0.00;
	planter.height = 0.00;
	if (planter.onLayout) planter.onLayout();
	const continueButton = this.continueButton;
	PlanterCustomizeLayout_continueButton.call(this.continueButton);
	continueButton.x = 929.75;
	continueButton.y = 620;
	continueButton.width = 133.50;
	continueButton.height = 138.00;
	if (continueButton.onLayout) continueButton.onLayout();
	return this;
}
function PlanterCustomizeLayout_bg(this: IPlanterCustomizeLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("PlanterParty-Background.png", 0.000, 0.000);
	return this;
}
function PlanterCustomizeLayout_tabsDropShadow(this: IPlanterCustomizeLayout_tabsDropShadow) {
	if (this.setLayoutTexture) this.setLayoutTexture("UIContainerShadow.png", 0.501, 0.501);
	return this;
}
function PlanterCustomizeLayout_bench(this: IPlanterCustomizeLayout_bench) {
	if (this.setLayoutTexture) this.setLayoutTexture("bench.png", 0.500, 0.500);
	return this;
}
function PlanterCustomizeLayout_tab1(this: IPlanterCustomizeLayout_tab1) {
	const buttons = this.buttons;
	if (!buttons[0] && buttons.elementFactory) {
		buttons[0] = buttons.elementFactory(0,undefined);
	}
	if (buttons[0]) {
		PlanterCustomizeLayout_optionButton.call(buttons[0] as IPlanterCustomizeLayout_optionButton);
		buttons[0].x = -75;
		buttons[0].y = -80;
		if (buttons[0].onLayout) buttons[0].onLayout();
	}
	if (!buttons[1] && buttons.elementFactory) {
		buttons[1] = buttons.elementFactory(1,undefined);
	}
	if (buttons[1]) {
		PlanterCustomizeLayout_optionButton.call(buttons[1] as IPlanterCustomizeLayout_optionButton);
		buttons[1].x = 75;
		buttons[1].y = -80;
		if (buttons[1].onLayout) buttons[1].onLayout();
	}
	if (!buttons[2] && buttons.elementFactory) {
		buttons[2] = buttons.elementFactory(2,undefined);
	}
	if (buttons[2]) {
		PlanterCustomizeLayout_optionButton.call(buttons[2] as IPlanterCustomizeLayout_optionButton);
		buttons[2].x = -75;
		buttons[2].y = 46.5;
		if (buttons[2].onLayout) buttons[2].onLayout();
	}
	if (!buttons[3] && buttons.elementFactory) {
		buttons[3] = buttons.elementFactory(3,undefined);
	}
	if (buttons[3]) {
		PlanterCustomizeLayout_optionButton.call(buttons[3] as IPlanterCustomizeLayout_optionButton);
		buttons[3].x = 75;
		buttons[3].y = 46.5;
		if (buttons[3].onLayout) buttons[3].onLayout();
	}
	if (!buttons[4] && buttons.elementFactory) {
		buttons[4] = buttons.elementFactory(4,undefined);
	}
	if (buttons[4]) {
		PlanterCustomizeLayout_optionButton.call(buttons[4] as IPlanterCustomizeLayout_optionButton);
		buttons[4].x = -75;
		buttons[4].y = 173;
		if (buttons[4].onLayout) buttons[4].onLayout();
	}
	const bgOff = this.bgOff;
	PlanterCustomizeLayout_tab1BgOff.call(this.bgOff);
	bgOff.x = 0;
	bgOff.y = 0;
	bgOff.width = 433.00;
	bgOff.height = 528.00;
	if (bgOff.onLayout) bgOff.onLayout();
	const bgOn = this.bgOn;
	PlanterCustomizeLayout_tab1bgOn.call(this.bgOn);
	bgOn.x = 0;
	bgOn.y = 0;
	bgOn.width = 433.00;
	bgOn.height = 528.00;
	if (bgOn.onLayout) bgOn.onLayout();
	const hitArea = this.hitArea;
	PlanterCustomizeLayout_hitArea.call(this.hitArea);
	hitArea.x = -206.5;
	hitArea.y = -253.7;
	hitArea.width = 113.75;
	hitArea.height = 92.00;
	if (hitArea.onLayout) hitArea.onLayout();
	const icon = this.icon;
	PlanterCustomizeLayout_tab1icon.call(this.icon);
	icon.x = -150;
	icon.y = -209.5;
	icon.width = 57.00;
	icon.height = 34.50;
	if (icon.onLayout) icon.onLayout();
	return this;
}
function PlanterCustomizeLayout_tab1BgOff(this: IPlanterCustomizeLayout_tab1BgOff) {
	if (this.setLayoutTexture) this.setLayoutTexture("PlantersUIGrey.png", 0.501, 0.500);
	return this;
}
function PlanterCustomizeLayout_tab1bgOn(this: IPlanterCustomizeLayout_tab1bgOn) {
	if (this.setLayoutTexture) this.setLayoutTexture("PlantersUIWhite.png", 0.501, 0.500);
	return this;
}
function PlanterCustomizeLayout_hitArea(this: IPlanterCustomizeLayout_hitArea) {
	return this;
}
function PlanterCustomizeLayout_optionButton(this: IPlanterCustomizeLayout_optionButton) {
	const bg = this.bg;
	PlanterCustomizeLayout_bgOff.call(this.bg);
	bg.x = 0;
	bg.y = 0;
	bg.width = 118.00;
	bg.height = 118.00;
	if (bg.onLayout) bg.onLayout();
	const bgOn = this.bgOn;
	PlanterCustomizeLayout_bgOn.call(this.bgOn);
	bgOn.x = 0;
	bgOn.y = 0;
	bgOn.width = 126.00;
	bgOn.height = 126.00;
	if (bgOn.onLayout) bgOn.onLayout();
	const check = this.check;
	PlanterCustomizeLayout_check.call(this.check);
	check.x = 37.5;
	check.y = 36;
	check.width = 41.00;
	check.height = 44.00;
	if (check.onLayout) check.onLayout();
	return this;
}
function PlanterCustomizeLayout_bgOff(this: IPlanterCustomizeLayout_bgOff) {
	if (this.setLayoutTexture) this.setLayoutTexture("CustomizeItemBack.png", 0.505, 0.505);
	return this;
}
function PlanterCustomizeLayout_bgOn(this: IPlanterCustomizeLayout_bgOn) {
	if (this.setLayoutTexture) this.setLayoutTexture("CustomizeItemBackSelect.png", 0.500, 0.500);
	return this;
}
function PlanterCustomizeLayout_check(this: IPlanterCustomizeLayout_check) {
	if (this.setLayoutTexture) this.setLayoutTexture("option-checkmark-on.png", 0.500, 0.500);
	return this;
}
function PlanterCustomizeLayout_tab1icon(this: IPlanterCustomizeLayout_tab1icon) {
	if (this.setLayoutTexture) this.setLayoutTexture("PlanterIcon.png", 0.509, 0.522);
	return this;
}
function PlanterCustomizeLayout_tab2(this: IPlanterCustomizeLayout_tab2) {
	const buttons = this.buttons;
	if (!buttons[0] && buttons.elementFactory) {
		buttons[0] = buttons.elementFactory(0,undefined);
	}
	if (buttons[0]) {
		PlanterCustomizeLayout_optionButton.call(buttons[0] as IPlanterCustomizeLayout_optionButton);
		buttons[0].x = -75;
		buttons[0].y = -80;
		if (buttons[0].onLayout) buttons[0].onLayout();
	}
	if (!buttons[1] && buttons.elementFactory) {
		buttons[1] = buttons.elementFactory(1,undefined);
	}
	if (buttons[1]) {
		PlanterCustomizeLayout_optionButton.call(buttons[1] as IPlanterCustomizeLayout_optionButton);
		buttons[1].x = 75;
		buttons[1].y = -80;
		if (buttons[1].onLayout) buttons[1].onLayout();
	}
	if (!buttons[2] && buttons.elementFactory) {
		buttons[2] = buttons.elementFactory(2,undefined);
	}
	if (buttons[2]) {
		PlanterCustomizeLayout_optionButton.call(buttons[2] as IPlanterCustomizeLayout_optionButton);
		buttons[2].x = -75;
		buttons[2].y = 46.5;
		if (buttons[2].onLayout) buttons[2].onLayout();
	}
	if (!buttons[3] && buttons.elementFactory) {
		buttons[3] = buttons.elementFactory(3,undefined);
	}
	if (buttons[3]) {
		PlanterCustomizeLayout_optionButton.call(buttons[3] as IPlanterCustomizeLayout_optionButton);
		buttons[3].x = 75;
		buttons[3].y = 46.5;
		if (buttons[3].onLayout) buttons[3].onLayout();
	}
	if (!buttons[4] && buttons.elementFactory) {
		buttons[4] = buttons.elementFactory(4,undefined);
	}
	if (buttons[4]) {
		PlanterCustomizeLayout_optionButton.call(buttons[4] as IPlanterCustomizeLayout_optionButton);
		buttons[4].x = -75;
		buttons[4].y = 173;
		if (buttons[4].onLayout) buttons[4].onLayout();
	}
	if (!buttons[5] && buttons.elementFactory) {
		buttons[5] = buttons.elementFactory(5,undefined);
	}
	if (buttons[5]) {
		PlanterCustomizeLayout_optionButton.call(buttons[5] as IPlanterCustomizeLayout_optionButton);
		buttons[5].x = 75;
		buttons[5].y = 173;
		if (buttons[5].onLayout) buttons[5].onLayout();
	}
	const bgOff = this.bgOff;
	PlanterCustomizeLayout_tab2BgOff.call(this.bgOff);
	bgOff.x = 0;
	bgOff.y = 0;
	bgOff.width = 433.00;
	bgOff.height = 528.00;
	if (bgOff.onLayout) bgOff.onLayout();
	const bgOn = this.bgOn;
	PlanterCustomizeLayout_tab2BgOn.call(this.bgOn);
	bgOn.x = 0;
	bgOn.y = 0;
	bgOn.width = 432.00;
	bgOn.height = 528.00;
	if (bgOn.onLayout) bgOn.onLayout();
	const hitArea = this.hitArea;
	PlanterCustomizeLayout_hitArea.call(this.hitArea);
	hitArea.x = -107.5;
	hitArea.y = -253.7;
	hitArea.width = 113.75;
	hitArea.height = 92.00;
	if (hitArea.onLayout) hitArea.onLayout();
	const icon = this.icon;
	PlanterCustomizeLayout_tab2Icon.call(this.icon);
	icon.x = -50;
	icon.y = -214;
	icon.width = 51.00;
	icon.height = 50.00;
	if (icon.onLayout) icon.onLayout();
	return this;
}
function PlanterCustomizeLayout_tab2BgOff(this: IPlanterCustomizeLayout_tab2BgOff) {
	if (this.setLayoutTexture) this.setLayoutTexture("ColoursUIGrey.png", 0.501, 0.500);
	return this;
}
function PlanterCustomizeLayout_tab2BgOn(this: IPlanterCustomizeLayout_tab2BgOn) {
	if (this.setLayoutTexture) this.setLayoutTexture("ColoursUIWhite.png", 0.500, 0.500);
	return this;
}
function PlanterCustomizeLayout_tab2Icon(this: IPlanterCustomizeLayout_tab2Icon) {
	if (this.setLayoutTexture) this.setLayoutTexture("ColourIcon.png", 0.510, 0.500);
	return this;
}
function PlanterCustomizeLayout_tab3(this: IPlanterCustomizeLayout_tab3) {
	const buttons = this.buttons;
	if (!buttons[0] && buttons.elementFactory) {
		buttons[0] = buttons.elementFactory(0,undefined);
	}
	if (buttons[0]) {
		PlanterCustomizeLayout_optionButton.call(buttons[0] as IPlanterCustomizeLayout_optionButton);
		buttons[0].x = -75;
		buttons[0].y = -80;
		if (buttons[0].onLayout) buttons[0].onLayout();
	}
	if (!buttons[1] && buttons.elementFactory) {
		buttons[1] = buttons.elementFactory(1,undefined);
	}
	if (buttons[1]) {
		PlanterCustomizeLayout_optionButton.call(buttons[1] as IPlanterCustomizeLayout_optionButton);
		buttons[1].x = 75;
		buttons[1].y = -80;
		if (buttons[1].onLayout) buttons[1].onLayout();
	}
	if (!buttons[2] && buttons.elementFactory) {
		buttons[2] = buttons.elementFactory(2,undefined);
	}
	if (buttons[2]) {
		PlanterCustomizeLayout_optionButton.call(buttons[2] as IPlanterCustomizeLayout_optionButton);
		buttons[2].x = -75;
		buttons[2].y = 46.5;
		if (buttons[2].onLayout) buttons[2].onLayout();
	}
	if (!buttons[3] && buttons.elementFactory) {
		buttons[3] = buttons.elementFactory(3,undefined);
	}
	if (buttons[3]) {
		PlanterCustomizeLayout_optionButton.call(buttons[3] as IPlanterCustomizeLayout_optionButton);
		buttons[3].x = 75;
		buttons[3].y = 46.5;
		if (buttons[3].onLayout) buttons[3].onLayout();
	}
	if (!buttons[4] && buttons.elementFactory) {
		buttons[4] = buttons.elementFactory(4,undefined);
	}
	if (buttons[4]) {
		PlanterCustomizeLayout_optionButton.call(buttons[4] as IPlanterCustomizeLayout_optionButton);
		buttons[4].x = -75;
		buttons[4].y = 173;
		if (buttons[4].onLayout) buttons[4].onLayout();
	}
	if (!buttons[5] && buttons.elementFactory) {
		buttons[5] = buttons.elementFactory(5,undefined);
	}
	if (buttons[5]) {
		PlanterCustomizeLayout_optionButton.call(buttons[5] as IPlanterCustomizeLayout_optionButton);
		buttons[5].x = 75;
		buttons[5].y = 173;
		if (buttons[5].onLayout) buttons[5].onLayout();
	}
	const bgOff = this.bgOff;
	PlanterCustomizeLayout_tab3bgOff.call(this.bgOff);
	bgOff.x = 0;
	bgOff.y = 0;
	bgOff.width = 433.00;
	bgOff.height = 528.00;
	if (bgOff.onLayout) bgOff.onLayout();
	const hitArea = this.hitArea;
	PlanterCustomizeLayout_hitArea.call(this.hitArea);
	hitArea.x = -7.5;
	hitArea.y = -253.7;
	hitArea.width = 113.75;
	hitArea.height = 92.00;
	if (hitArea.onLayout) hitArea.onLayout();
	const bgOn = this.bgOn;
	PlanterCustomizeLayout_tab3bgOn.call(this.bgOn);
	bgOn.x = 0;
	bgOn.y = 0;
	bgOn.width = 432.00;
	bgOn.height = 528.00;
	if (bgOn.onLayout) bgOn.onLayout();
	const icon = this.icon;
	PlanterCustomizeLayout_tab3icon.call(this.icon);
	icon.x = 49.5;
	icon.y = -207.5;
	icon.width = 59.50;
	icon.height = 45.50;
	if (icon.onLayout) icon.onLayout();
	return this;
}
function PlanterCustomizeLayout_tab3bgOff(this: IPlanterCustomizeLayout_tab3bgOff) {
	if (this.setLayoutTexture) this.setLayoutTexture("PatternsUIGrey.png", 0.501, 0.500);
	return this;
}
function PlanterCustomizeLayout_tab3bgOn(this: IPlanterCustomizeLayout_tab3bgOn) {
	if (this.setLayoutTexture) this.setLayoutTexture("PatternsUIWhite.png", 0.500, 0.500);
	return this;
}
function PlanterCustomizeLayout_tab3icon(this: IPlanterCustomizeLayout_tab3icon) {
	if (this.setLayoutTexture) this.setLayoutTexture("PatternIcon.png", 0.504, 0.505);
	return this;
}
function PlanterCustomizeLayout_tab4(this: IPlanterCustomizeLayout_tab4) {
	const buttons = this.buttons;
	if (!buttons[0] && buttons.elementFactory) {
		buttons[0] = buttons.elementFactory(0,undefined);
	}
	if (buttons[0]) {
		PlanterCustomizeLayout_optionButton.call(buttons[0] as IPlanterCustomizeLayout_optionButton);
		buttons[0].x = -75;
		buttons[0].y = -80;
		if (buttons[0].onLayout) buttons[0].onLayout();
	}
	if (!buttons[1] && buttons.elementFactory) {
		buttons[1] = buttons.elementFactory(1,undefined);
	}
	if (buttons[1]) {
		PlanterCustomizeLayout_optionButton.call(buttons[1] as IPlanterCustomizeLayout_optionButton);
		buttons[1].x = 75;
		buttons[1].y = -80;
		if (buttons[1].onLayout) buttons[1].onLayout();
	}
	if (!buttons[2] && buttons.elementFactory) {
		buttons[2] = buttons.elementFactory(2,undefined);
	}
	if (buttons[2]) {
		PlanterCustomizeLayout_optionButton.call(buttons[2] as IPlanterCustomizeLayout_optionButton);
		buttons[2].x = -75;
		buttons[2].y = 46.5;
		if (buttons[2].onLayout) buttons[2].onLayout();
	}
	if (!buttons[3] && buttons.elementFactory) {
		buttons[3] = buttons.elementFactory(3,undefined);
	}
	if (buttons[3]) {
		PlanterCustomizeLayout_optionButton.call(buttons[3] as IPlanterCustomizeLayout_optionButton);
		buttons[3].x = 75;
		buttons[3].y = 46.5;
		if (buttons[3].onLayout) buttons[3].onLayout();
	}
	if (!buttons[4] && buttons.elementFactory) {
		buttons[4] = buttons.elementFactory(4,undefined);
	}
	if (buttons[4]) {
		PlanterCustomizeLayout_optionButton.call(buttons[4] as IPlanterCustomizeLayout_optionButton);
		buttons[4].x = -75;
		buttons[4].y = 173;
		if (buttons[4].onLayout) buttons[4].onLayout();
	}
	if (!buttons[5] && buttons.elementFactory) {
		buttons[5] = buttons.elementFactory(5,undefined);
	}
	if (buttons[5]) {
		PlanterCustomizeLayout_optionButton.call(buttons[5] as IPlanterCustomizeLayout_optionButton);
		buttons[5].x = 75;
		buttons[5].y = 173;
		if (buttons[5].onLayout) buttons[5].onLayout();
	}
	const bgOff = this.bgOff;
	PlanterCustomizeLayout_tab4bgOff.call(this.bgOff);
	bgOff.x = 0;
	bgOff.y = 0;
	bgOff.width = 433.00;
	bgOff.height = 528.00;
	if (bgOff.onLayout) bgOff.onLayout();
	const hitArea = this.hitArea;
	PlanterCustomizeLayout_hitArea.call(this.hitArea);
	hitArea.x = 92.5;
	hitArea.y = -253.7;
	hitArea.width = 113.75;
	hitArea.height = 92.00;
	if (hitArea.onLayout) hitArea.onLayout();
	const bgOn = this.bgOn;
	PlanterCustomizeLayout_tab4bgOn.call(this.bgOn);
	bgOn.x = 0;
	bgOn.y = 0;
	bgOn.width = 433.00;
	bgOn.height = 528.00;
	if (bgOn.onLayout) bgOn.onLayout();
	const icon = this.icon;
	PlanterCustomizeLayout_tab4icon.call(this.icon);
	icon.x = 152;
	icon.y = -209.95;
	icon.width = 31.50;
	icon.height = 61.00;
	if (icon.onLayout) icon.onLayout();
	return this;
}
function PlanterCustomizeLayout_tab4bgOff(this: IPlanterCustomizeLayout_tab4bgOff) {
	if (this.setLayoutTexture) this.setLayoutTexture("StickersUIGrey.png", 0.500, 0.500);
	return this;
}
function PlanterCustomizeLayout_tab4bgOn(this: IPlanterCustomizeLayout_tab4bgOn) {
	if (this.setLayoutTexture) this.setLayoutTexture("StickersUIWhite.png", 0.501, 0.500);
	return this;
}
function PlanterCustomizeLayout_tab4icon(this: IPlanterCustomizeLayout_tab4icon) {
	if (this.setLayoutTexture) this.setLayoutTexture("StickersIcon.png", 0.508, 0.508);
	return this;
}
function PlanterCustomizeLayout_homeButton(this: IPlanterCustomizeLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
function PlanterCustomizeLayout_planter(this: IPlanterCustomizeLayout_planter) {
	return this;
}
function PlanterCustomizeLayout_continueButton(this: IPlanterCustomizeLayout_continueButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("ArrowBTN.png", 0.500, 0.500);
	return this;
}
interface IPlanterCustomizeLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPlanterCustomizeLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPlanterCustomizeLayoutSprite extends IPlanterCustomizeLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPlanterCustomizeLayoutText extends IPlanterCustomizeLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPlanterCustomizeLayoutPolygon extends Array<number> {
}
interface IPlanterCustomizeLayout {
	readonly tab: IPlanterCustomizeLayoutArray<IPlanterCustomizeLayout_tab1|IPlanterCustomizeLayout_tab2|IPlanterCustomizeLayout_tab3|IPlanterCustomizeLayout_tab4>;
	readonly bg: IPlanterCustomizeLayout_bg;
	readonly tabsDropShadow: IPlanterCustomizeLayout_tabsDropShadow;
	readonly bench: IPlanterCustomizeLayout_bench;
	readonly homeButton: IPlanterCustomizeLayout_homeButton;
	readonly planter: IPlanterCustomizeLayout_planter;
	readonly continueButton: IPlanterCustomizeLayout_continueButton;
}
interface IPlanterCustomizeLayout_bg extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_tabsDropShadow extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_bench extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_tab1 extends IPlanterCustomizeLayoutContainer {
	readonly buttons: IPlanterCustomizeLayoutArray<IPlanterCustomizeLayout_optionButton>;
	readonly bgOff: IPlanterCustomizeLayout_tab1BgOff;
	readonly bgOn: IPlanterCustomizeLayout_tab1bgOn;
	readonly hitArea: IPlanterCustomizeLayout_hitArea;
	readonly icon: IPlanterCustomizeLayout_tab1icon;
}
interface IPlanterCustomizeLayout_tab1BgOff extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_tab1bgOn extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_hitArea extends IPlanterCustomizeLayoutContainer {
}
interface IPlanterCustomizeLayout_optionButton extends IPlanterCustomizeLayoutContainer {
	readonly bg: IPlanterCustomizeLayout_bgOff;
	readonly bgOn: IPlanterCustomizeLayout_bgOn;
	readonly check: IPlanterCustomizeLayout_check;
}
interface IPlanterCustomizeLayout_bgOff extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_bgOn extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_check extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_tab1icon extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_tab2 extends IPlanterCustomizeLayoutContainer {
	readonly buttons: IPlanterCustomizeLayoutArray<IPlanterCustomizeLayout_optionButton>;
	readonly bgOff: IPlanterCustomizeLayout_tab2BgOff;
	readonly bgOn: IPlanterCustomizeLayout_tab2BgOn;
	readonly hitArea: IPlanterCustomizeLayout_hitArea;
	readonly icon: IPlanterCustomizeLayout_tab2Icon;
}
interface IPlanterCustomizeLayout_tab2BgOff extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_tab2BgOn extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_tab2Icon extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_tab3 extends IPlanterCustomizeLayoutContainer {
	readonly buttons: IPlanterCustomizeLayoutArray<IPlanterCustomizeLayout_optionButton>;
	readonly bgOff: IPlanterCustomizeLayout_tab3bgOff;
	readonly hitArea: IPlanterCustomizeLayout_hitArea;
	readonly bgOn: IPlanterCustomizeLayout_tab3bgOn;
	readonly icon: IPlanterCustomizeLayout_tab3icon;
}
interface IPlanterCustomizeLayout_tab3bgOff extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_tab3bgOn extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_tab3icon extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_tab4 extends IPlanterCustomizeLayoutContainer {
	readonly buttons: IPlanterCustomizeLayoutArray<IPlanterCustomizeLayout_optionButton>;
	readonly bgOff: IPlanterCustomizeLayout_tab4bgOff;
	readonly hitArea: IPlanterCustomizeLayout_hitArea;
	readonly bgOn: IPlanterCustomizeLayout_tab4bgOn;
	readonly icon: IPlanterCustomizeLayout_tab4icon;
}
interface IPlanterCustomizeLayout_tab4bgOff extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_tab4bgOn extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_tab4icon extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_homeButton extends IPlanterCustomizeLayoutSprite {
}
interface IPlanterCustomizeLayout_planter extends IPlanterCustomizeLayoutContainer {
}
interface IPlanterCustomizeLayout_continueButton extends IPlanterCustomizeLayoutSprite {
}
